import { useState } from "react";
import { strings } from "@/data/strings";
import { SectionHeader } from "@/components/SectionHeader";
import { useInView } from "@/hooks/useInView";
import styles from "./FAQ.module.css";

function cx(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(" ");
}

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref, inView } = useInView<HTMLDivElement>({
    threshold: 0,
    rootMargin: "0px 0px -20% 0px",
  });

  return (
    <section id="faq" className={styles.section}>
      <div className="container">
        <SectionHeader
          align="center"
          eyebrow={strings.faq.eyebrow}
          title={strings.faq.title}
          subtitle={strings.faq.subtitle}
        />

        <div ref={ref} className={cx(styles.list, inView && styles.revealed)}>
          {strings.faq.items.map((item, index) => {
            const isOpen = openIndex === index;
            const questionId = `faq-q-${index}`;
            const panelId = `faq-p-${index}`;
            return (
              <article
                key={questionId}
                className={cx(styles.item, isOpen && styles.itemOpen)}>
                <h3 className={styles.itemHeading}>
                  <button
                    id={questionId}
                    type="button"
                    className={styles.trigger}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(isOpen ? null : index)}>
                    <span className={styles.question}>{item.question}</span>
                    <span className={styles.right}>
                      <span
                        className={styles.tag}
                        data-audience={item.audience}>
                        {strings.faq.audienceLabel[item.audience]}
                      </span>
                      <span className={styles.chevron} aria-hidden="true">
                        <svg
                          viewBox="0 0 20 20"
                          width="20"
                          height="20"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round">
                          <path d="M5 8 L10 13 L15 8" />
                        </svg>
                      </span>
                    </span>
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={questionId}
                  className={styles.panel}>
                  <div className={styles.panelInner}>
                    <p>{item.answer}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
